import {
  formDataRequest,
  getRequest,
  postRequest,
} from "../libs/AxiosService.util";

export async function serviceCreateMemberPolls(params) {
  return await formDataRequest("polls/create", params);
}
export async function serviceUpdateMemberPolls(params) {
  return await formDataRequest("polls/update", params);
}
export async function serviceDeleteMemberPolls(params) {
  return await postRequest("polls/delete", params);
}
export async function serviceGetMemberPollsDetails(params) {
  return await postRequest("polls/detail", params);
}
export async function serviceGetMemberPolls(params) {
  return await postRequest("polls", params);
}
export async function serviceDetailsMemberPolls(params) {
  return await postRequest("polls/detail", params);
}
export async function serviceUpdateMemberPollsStatus(params) {
  return await postRequest("polls/app/show", params);
}
export async function serviceGetMemberPollsStatus(params) {
  return await postRequest("polls/home", params);
}
